export const { MODE } = import.meta.env;
